import { parse, format } from 'date-fns'

const formatSeconds = (seconds: number) => {
  const parsedDate = parse(seconds.toString(), 't', new Date())
  return format(parsedDate, 'mm:ss')
}

export { formatSeconds }
